const constants = {
    module: {
        time_reporting_clocker: 1,
        cash_guard: 2,
        customer_card_refill: 3,
        subsidies: 4,
        production_order: 5,
        digital_signage: 6,
        web_catering: 7,
        sms: 8,
        webshop: 9,
        accounting: 10,
        invoice: 11,
        api_access: 12,
        webshop_integration: 13
    }
};
$.extend({}, constants);